import React from 'react';

// Generated from the LegalApp design canvas.
export default function HeroThana({ style }) {
  style = { ...{  }, ...style };
  return (
    <svg className="lp-hero-iso lp-thana-iso" viewBox="-266.9 -131.5 586.5 441.5" role="img" aria-label="Illustration: a police station with its front walls cut away, showing the duty desk, interview room, evidence store and SHO's office, with a thread carrying the case from room to room up to a finished chargesheet" style={style}>
    <polygon points="304.8,150.0 52.0,296.0 52.0,288.0 304.8,142.0" fill="#B5CAF2" />
    <polygon points="-252.9,120.0 52.0,296.0 52.0,288.0 -252.9,112.0" fill="#D3E0F8" />
    <polygon points="0.0,-34.0 304.8,142.0 52.0,288.0 -252.9,112.0" fill="#EEF3FD" />
    <polygon points="0.0,-8.0 259.8,142.0 52.0,262.0 -207.8,112.0" fill="#FFFFFF" />
    <polygon points="-106.5,53.5 20.8,127.0 -80.5,185.5 -207.8,112.0" fill="#FFCB7E" className="lp-room-glow lp-g1" />
    <polygon points="26.0,130.0 153.3,203.5 52.0,262.0 -75.3,188.5" fill="#FFCB7E" className="lp-room-glow lp-g2" />
    <polygon points="132.5,68.5 259.8,142.0 158.5,200.5 31.2,127.0" fill="#FFCB7E" className="lp-room-glow lp-g3" />
    <polygon points="0.0,-8.0 127.3,65.5 26.0,124.0 -101.3,50.5" fill="#FFCB7E" className="lp-room-glow lp-g4" />
    <polygon points="-168.9,134.5 -134.2,154.5 -156.8,167.5 -191.4,147.5" fill="#FFFFFF" />
    <polygon points="0.0,-8.0 -207.8,112.0 -207.8,16.0 0.0,-104.0" fill="#E8EFFD" />
    <polygon points="-214.8,108.0 -207.8,112.0 -207.8,16.0 -214.8,12.0" fill="#F3F7FE" />
    <polygon points="-6.9,-108.0 0.0,-104.0 -207.8,16.0 -214.8,12.0" fill="#16284D" />
    <polygon points="266.7,138.0 259.8,142.0 259.8,46.0 266.7,42.0" fill="#DCE6FA" />
    <polygon points="-6.9,-12.0 259.8,142.0 259.8,46.0 -6.9,-108.0" fill="#FFFFFF" />
    <polygon points="0.0,-112.0 266.7,42.0 259.8,46.0 -6.9,-108.0" fill="#16284D" />
    <polygon points="-131.6,34.0 -176.7,60.0 -176.7,26.0 -131.6,0.0" fill="#16284D" />
    <polygon points="-133.8,32.8 -174.5,56.2 -174.5,27.2 -133.8,3.8" fill="#CFE0FB" />
    <polygon points="-153.3,44.0 -155.0,45.0 -155.0,16.0 -153.3,15.0" fill="#16284D" />
    <polygon points="-133.8,19.2 -174.5,42.8 -174.5,40.8 -133.8,17.2" fill="#16284D" />
    <polygon points="-26.0,-27.0 -71.0,-1.0 -71.0,-35.0 -26.0,-61.0" fill="#16284D" />
    <polygon points="-28.1,-28.2 -68.8,-4.8 -68.8,-33.8 -28.1,-57.2" fill="#CFE0FB" />
    <polygon points="-47.6,-17.0 -49.4,-16.0 -49.4,-45.0 -47.6,-46.0" fill="#16284D" />
    <polygon points="-28.1,-41.8 -68.8,-18.2 -68.8,-20.2 -28.1,-43.8" fill="#16284D" />
    <polygon points="10.4,-34.0 72.7,2.0 72.7,-44.0 10.4,-80.0" fill="#16284D" />
    <polygon points="13.0,-35.5 70.1,-2.5 70.1,-42.5 13.0,-75.5" fill="#FFFFFF" />
    <polygon points="18.2,-63.5 44.2,-48.5 44.2,-52.5 18.2,-67.5" fill="#0B1B3F" />
    <polygon points="18.2,-52.5 65.0,-25.5 65.0,-29.5 18.2,-56.5" fill="#E4EDFD" />
    <polygon points="18.2,-52.5 56.3,-30.5 56.3,-34.5 18.2,-56.5" fill="#2563DE" />
    <polygon points="18.2,-44.0 65.0,-17.0 65.0,-21.0 18.2,-48.0" fill="#E4EDFD" />
    <polygon points="18.2,-44.0 45.9,-28.0 45.9,-32.0 18.2,-48.0" fill="#2563DE" />
    <polygon points="18.2,-35.5 65.0,-8.5 65.0,-12.5 18.2,-39.5" fill="#E4EDFD" />
    <polygon points="18.2,-35.5 35.5,-25.5 35.5,-29.5 18.2,-39.5" fill="#F2A33A" />
    <polygon points="-51.1,-77.5 -186.2,0.5 -186.2,-37.5 -51.1,-115.5" fill="#1A4DB8" />
    <polygon points="-189.7,-1.5 -186.2,0.5 -186.2,-37.5 -189.7,-39.5" fill="#2563DE" />
    <polygon points="-54.6,-117.5 -51.1,-115.5 -186.2,-37.5 -189.7,-39.5" fill="#4C81EC" />
    <text transform="matrix(0.8660 -0.5 0 1 -177.5 -26.5)" className="lp-iso-sign-hi" fill="#FFFFFF">
      {"पुलिस थाना"}
    </text>
    <text transform="matrix(0.8660 -0.5 0 1 -177.5 -12.5)" className="lp-iso-sign-en" fill="#DCE7FC">
      {"POLICE STATION"}
    </text>
    <polyline points="-175.8,158.0 -127.3,130.0 -81.4,156.5 -58.9,143.5 34.6,197.5 138.6,137.5 57.2,90.5" className="lp-iso-thread-glow" />
    <polyline points="-175.8,158.0 -127.3,130.0 -81.4,156.5 -58.9,143.5 34.6,197.5 138.6,137.5 57.2,90.5" className="lp-iso-thread" />
    <path d="M10.4 62.0 L10.4 37.0 L31.2 37.0 L31.2 62.0 A10.4 6.0 0 0 1 10.4 62.0 Z" fill="#0B1B3F" />
    <ellipse cx="20.8" cy="37.0" rx="10.4" ry="6.0" fill="#2A3D69" />
    <circle cx="20.8" cy="25.5" r="8.1" fill="#2A3D69" />
    <polygon points="81.4,69.0 32.9,97.0 32.9,77.0 81.4,49.0" fill="#BCD1F8" />
    <polygon points="8.7,83.0 32.9,97.0 32.9,77.0 8.7,63.0" fill="#E4EDFD" />
    <polygon points="57.2,35.0 81.4,49.0 32.9,77.0 8.7,63.0" fill="#FFFFFF" />
    <polygon points="53.7,45.0 32.9,57.0 32.9,42.0 53.7,30.0" fill="#0B1B3F" />
    <polygon points="30.3,55.5 32.9,57.0 32.9,42.0 30.3,40.5" fill="#16284D" />
    <polygon points="51.1,28.5 53.7,30.0 32.9,42.0 30.3,40.5" fill="#2A3D69" />
    <polygon points="52.0,44.0 34.6,54.0 34.6,43.0 52.0,33.0" fill="#EAF1FE" />
    <polygon points="46.8,41.0 36.4,47.0 36.4,44.5 46.8,38.5" fill="#2563DE" />
    <polygon points="48.5,44.0 34.6,52.0 34.6,49.5 48.5,41.5" fill="#BCD1F8" />
    <polygon points="45.9,66.5 35.5,72.5 35.5,69.5 45.9,63.5" fill="#D7861F" />
    <polygon points="24.2,66.0 35.5,72.5 35.5,69.5 24.2,63.0" fill="#F2A33A" />
    <polygon points="34.6,57.0 45.9,63.5 35.5,69.5 24.2,63.0" fill="#FFCB7E" />
    <polygon points="45.9,63.5 35.5,69.5 35.5,66.5 45.9,60.5" fill="#1A4DB8" />
    <polygon points="24.2,63.0 35.5,69.5 35.5,66.5 24.2,60.0" fill="#2563DE" />
    <polygon points="34.6,54.0 45.9,60.5 35.5,66.5 24.2,60.0" fill="#4C81EC" />
    <polygon points="31.2,127.0 26.0,130.0 26.0,114.0 31.2,111.0" fill="#E2EAFB" />
    <polygon points="-106.5,53.5 26.0,130.0 26.0,114.0 -106.5,37.5" fill="#FFFFFF" />
    <polygon points="-101.3,34.5 31.2,111.0 26.0,114.0 -106.5,37.5" fill="#16284D" />
    <polygon points="132.5,68.5 89.2,93.5 89.2,77.5 132.5,52.5" fill="#E2EAFB" />
    <polygon points="84.0,90.5 89.2,93.5 89.2,77.5 84.0,74.5" fill="#FFFFFF" />
    <polygon points="127.3,49.5 132.5,52.5 89.2,77.5 84.0,74.5" fill="#16284D" />
    <polygon points="63.2,108.5 31.2,127.0 31.2,111.0 63.2,92.5" fill="#E2EAFB" />
    <polygon points="26.0,124.0 31.2,127.0 31.2,111.0 26.0,108.0" fill="#FFFFFF" />
    <polygon points="58.0,89.5 63.2,92.5 31.2,111.0 26.0,108.0" fill="#16284D" />
    <path d="M-141.4 92.0 L-141.4 68.0 L-121.8 68.0 L-121.8 92.0 A9.8 5.7 0 0 1 -141.4 92.0 Z" fill="#0B1B3F" />
    <ellipse cx="-131.6" cy="68.0" rx="9.8" ry="5.7" fill="#2A3D69" />
    <circle cx="-131.6" cy="57.2" r="7.6" fill="#2A3D69" />
    <polygon points="-71.0,101.0 -116.0,127.0 -116.0,107.0 -71.0,81.0" fill="#BCD1F8" />
    <polygon points="-140.3,113.0 -116.0,127.0 -116.0,107.0 -140.3,93.0" fill="#E4EDFD" />
    <polygon points="-95.3,67.0 -71.0,81.0 -116.0,107.0 -140.3,93.0" fill="#FFFFFF" />
    <polygon points="-96.1,76.5 -120.4,90.5 -120.4,71.5 -96.1,57.5" fill="#0B1B3F" />
    <polygon points="-123.0,89.0 -120.4,90.5 -120.4,71.5 -123.0,70.0" fill="#16284D" />
    <polygon points="-98.7,56.0 -96.1,57.5 -120.4,71.5 -123.0,70.0" fill="#2A3D69" />
    <polygon points="-97.9,75.5 -118.6,87.5 -118.6,72.5 -97.9,60.5" fill="#EAF1FE" />
    <polygon points="-104.8,69.5 -116.9,76.5 -116.9,74.0 -104.8,67.0" fill="#2563DE" />
    <polygon points="-101.3,72.0 -116.9,81.0 -116.9,78.5 -101.3,69.5" fill="#BCD1F8" />
    <polygon points="-108.3,80.5 -116.9,85.5 -116.9,83.0 -108.3,78.0" fill="#F2A33A" />
    <polygon points="-119.5,95.0 -110.9,100.0 -117.8,104.0 -126.4,99.0" fill="#F2A33A" />
    <path d="M-73.9 127.0 L-73.9 103.0 L-54.3 103.0 L-54.3 127.0 A9.8 5.7 0 0 1 -73.9 127.0 Z" fill="#97ACD6" />
    <ellipse cx="-64.1" cy="103.0" rx="9.8" ry="5.7" fill="#D3DDF0" />
    <circle cx="-64.1" cy="92.2" r="7.6" fill="#D3DDF0" />
    <polygon points="26.0,130.0 -14.7,153.5 -14.7,137.5 26.0,114.0" fill="#E2EAFB" />
    <polygon points="-19.9,150.5 -14.7,153.5 -14.7,137.5 -19.9,134.5" fill="#FFFFFF" />
    <polygon points="20.8,111.0 26.0,114.0 -14.7,137.5 -19.9,134.5" fill="#16284D" />
    <polygon points="-40.7,168.5 -75.3,188.5 -75.3,172.5 -40.7,152.5" fill="#E2EAFB" />
    <polygon points="-80.5,185.5 -75.3,188.5 -75.3,172.5 -80.5,169.5" fill="#FFFFFF" />
    <polygon points="-45.9,149.5 -40.7,152.5 -75.3,172.5 -80.5,169.5" fill="#16284D" />
    <polygon points="143.8,81.0 121.2,94.0 121.2,22.0 143.8,9.0" fill="#0B1B3F" />
    <polygon points="117.8,92.0 121.2,94.0 121.2,22.0 117.8,20.0" fill="#16284D" />
    <polygon points="140.3,7.0 143.8,9.0 121.2,22.0 117.8,20.0" fill="#2A3D69" />
    <polygon points="237.3,115.0 214.8,128.0 214.8,125.0 237.3,112.0" fill="#BCD1F8" />
    <polygon points="117.8,72.0 214.8,128.0 214.8,125.0 117.8,69.0" fill="#E4EDFD" />
    <polygon points="140.3,56.0 237.3,112.0 214.8,125.0 117.8,69.0" fill="#FFFFFF" />
    <polygon points="158.5,70.5 143.8,79.0 143.8,65.0 158.5,56.5" fill="#D7861F" />
    <polygon points="129.0,70.5 143.8,79.0 143.8,65.0 129.0,56.5" fill="#F2A33A" />
    <polygon points="143.8,48.0 158.5,56.5 143.8,65.0 129.0,56.5" fill="#FFCB7E" />
    <polygon points="180.1,83.0 165.4,91.5 165.4,77.5 180.1,69.0" fill="#BCD1F8" />
    <polygon points="150.7,83.0 165.4,91.5 165.4,77.5 150.7,69.0" fill="#E4EDFD" />
    <polygon points="165.4,60.5 180.1,69.0 165.4,77.5 150.7,69.0" fill="#FFFFFF" />
    <polygon points="201.8,95.5 187.1,104.0 187.1,90.0 201.8,81.5" fill="#D7861F" />
    <polygon points="172.3,95.5 187.1,104.0 187.1,90.0 172.3,81.5" fill="#F2A33A" />
    <polygon points="187.1,73.0 201.8,81.5 187.1,90.0 172.3,81.5" fill="#FFCB7E" />
    <polygon points="223.4,108.0 208.7,116.5 208.7,102.5 223.4,94.0" fill="#BCD1F8" />
    <polygon points="194.0,108.0 208.7,116.5 208.7,102.5 194.0,94.0" fill="#E4EDFD" />
    <polygon points="208.7,85.5 223.4,94.0 208.7,102.5 194.0,94.0" fill="#FFFFFF" />
    <polygon points="237.3,91.0 214.8,104.0 214.8,101.0 237.3,88.0" fill="#BCD1F8" />
    <polygon points="117.8,48.0 214.8,104.0 214.8,101.0 117.8,45.0" fill="#E4EDFD" />
    <polygon points="140.3,32.0 237.3,88.0 214.8,101.0 117.8,45.0" fill="#FFFFFF" />
    <polygon points="158.5,46.5 143.8,55.0 143.8,41.0 158.5,32.5" fill="#BCD1F8" />
    <polygon points="129.0,46.5 143.8,55.0 143.8,41.0 129.0,32.5" fill="#E4EDFD" />
    <polygon points="143.8,24.0 158.5,32.5 143.8,41.0 129.0,32.5" fill="#FFFFFF" />
    <polygon points="180.1,59.0 165.4,67.5 165.4,53.5 180.1,45.0" fill="#D7861F" />
    <polygon points="150.7,59.0 165.4,67.5 165.4,53.5 150.7,45.0" fill="#F2A33A" />
    <polygon points="165.4,36.5 180.1,45.0 165.4,53.5 150.7,45.0" fill="#FFCB7E" />
    <polygon points="201.8,71.5 187.1,80.0 187.1,66.0 201.8,57.5" fill="#BCD1F8" />
    <polygon points="172.3,71.5 187.1,80.0 187.1,66.0 172.3,57.5" fill="#E4EDFD" />
    <polygon points="187.1,49.0 201.8,57.5 187.1,66.0 172.3,57.5" fill="#FFFFFF" />
    <polygon points="223.4,84.0 208.7,92.5 208.7,78.5 223.4,70.0" fill="#D7861F" />
    <polygon points="194.0,84.0 208.7,92.5 208.7,78.5 194.0,70.0" fill="#F2A33A" />
    <polygon points="208.7,61.5 223.4,70.0 208.7,78.5 194.0,70.0" fill="#FFCB7E" />
    <polygon points="237.3,67.0 214.8,80.0 214.8,77.0 237.3,64.0" fill="#BCD1F8" />
    <polygon points="117.8,24.0 214.8,80.0 214.8,77.0 117.8,21.0" fill="#E4EDFD" />
    <polygon points="140.3,8.0 237.3,64.0 214.8,77.0 117.8,21.0" fill="#FFFFFF" />
    <polygon points="237.3,135.0 214.8,148.0 214.8,76.0 237.3,63.0" fill="#0B1B3F" />
    <polygon points="211.3,146.0 214.8,148.0 214.8,76.0 211.3,74.0" fill="#16284D" />
    <polygon points="233.8,61.0 237.3,63.0 214.8,76.0 211.3,74.0" fill="#2A3D69" />
    <polygon points="225.2,158.0 185.3,181.0 185.3,147.0 225.2,124.0" fill="#D7861F" />
    <polygon points="140.3,155.0 185.3,181.0 185.3,147.0 140.3,121.0" fill="#F2A33A" />
    <polygon points="180.1,98.0 225.2,124.0 185.3,147.0 140.3,121.0" fill="#FFCB7E" />
    <polygon points="162.8,108.0 207.8,134.0 202.6,137.0 157.6,111.0" fill="#0B1B3F" opacity="0.85" />
    <polygon points="207.8,146.0 202.6,149.0 202.6,137.0 207.8,134.0" fill="#0B1B3F" opacity="0.85" />
    <polygon points="154.2,169.0 150.7,171.0 150.7,149.0 154.2,147.0" fill="#BCD1F8" />
    <polygon points="128.2,158.0 150.7,171.0 150.7,149.0 128.2,136.0" fill="#E4EDFD" />
    <polygon points="131.6,134.0 154.2,147.0 150.7,149.0 128.2,136.0" fill="#FFFFFF" />
    <text transform="matrix(0.8660 0.5 0 1 131.6 152.0)" className="lp-iso-tag" fill="#0B1B3F">
      {"E-1"}
    </text>
    <polygon points="80.5,155.5 75.3,158.5 75.3,142.5 80.5,139.5" fill="#E2EAFB" />
    <polygon points="26.0,130.0 75.3,158.5 75.3,142.5 26.0,114.0" fill="#FFFFFF" />
    <polygon points="31.2,111.0 80.5,139.5 75.3,142.5 26.0,114.0" fill="#16284D" />
    <polygon points="158.5,200.5 153.3,203.5 153.3,187.5 158.5,184.5" fill="#E2EAFB" />
    <polygon points="101.3,173.5 153.3,203.5 153.3,187.5 101.3,157.5" fill="#FFFFFF" />
    <polygon points="106.5,154.5 158.5,184.5 153.3,187.5 101.3,157.5" fill="#16284D" />
    <path d="M-2.9 178.0 L-2.9 154.0 L16.7 154.0 L16.7 178.0 A9.8 5.7 0 0 1 -2.9 178.0 Z" fill="#0B1B3F" />
    <ellipse cx="6.9" cy="154.0" rx="9.8" ry="5.7" fill="#2A3D69" />
    <circle cx="6.9" cy="143.2" r="7.6" fill="#2A3D69" />
    <polygon points="77.9,197.0 39.8,219.0 39.8,201.0 77.9,179.0" fill="#BCD1F8" />
    <polygon points="1.7,197.0 39.8,219.0 39.8,201.0 1.7,179.0" fill="#E4EDFD" />
    <polygon points="39.8,157.0 77.9,179.0 39.8,201.0 1.7,179.0" fill="#FFFFFF" />
    <polygon points="48.5,170.0 41.6,174.0 41.6,170.0 48.5,166.0" fill="#0B1B3F" />
    <polygon points="32.9,169.0 41.6,174.0 41.6,170.0 32.9,165.0" fill="#16284D" />
    <polygon points="39.8,161.0 48.5,166.0 41.6,170.0 32.9,165.0" fill="#2A3D69" />
    <polygon points="39.8,162.9 42.4,164.4 39.8,165.9 37.2,164.4" fill="#F2A33A" />
    <polygon points="43.3,178.9 55.4,185.9 39.8,194.9 27.7,187.9" fill="#FFFFFF" className="lp-iso-paper" />
    <polygon points="43.3,181.8 44.7,182.6 34.3,188.6 32.9,187.8" fill="#BCD1F8" />
    <polygon points="46.8,183.8 48.2,184.6 40.4,189.1 39.0,188.3" fill="#BCD1F8" />
    <polygon points="50.2,185.8 51.6,186.6 46.4,189.6 45.0,188.8" fill="#BCD1F8" />
    <path d="M62.9 220.0 L62.9 196.0 L82.5 196.0 L82.5 220.0 A9.8 5.7 0 0 1 62.9 220.0 Z" fill="#97ACD6" />
    <ellipse cx="72.7" cy="196.0" rx="9.8" ry="5.7" fill="#D3DDF0" />
    <circle cx="72.7" cy="185.2" r="7.6" fill="#D3DDF0" />
    <polygon points="-168.9,134.5 -174.1,137.5 -174.1,121.5 -168.9,118.5" fill="#E2EAFB" />
    <polygon points="-213.0,115.0 -174.1,137.5 -174.1,121.5 -213.0,99.0" fill="#FFFFFF" />
    <polygon points="-207.8,96.0 -168.9,118.5 -174.1,121.5 -213.0,99.0" fill="#16284D" />
    <polygon points="57.2,265.0 52.0,268.0 52.0,252.0 57.2,249.0" fill="#E2EAFB" />
    <polygon points="-139.4,157.5 52.0,268.0 52.0,252.0 -139.4,141.5" fill="#FFFFFF" />
    <polygon points="-134.2,138.5 57.2,249.0 52.0,252.0 -139.4,141.5" fill="#16284D" />
    <polygon points="265.0,145.0 57.2,265.0 57.2,249.0 265.0,129.0" fill="#E2EAFB" />
    <polygon points="52.0,262.0 57.2,265.0 57.2,249.0 52.0,246.0" fill="#FFFFFF" />
    <polygon points="259.8,126.0 265.0,129.0 57.2,249.0 52.0,246.0" fill="#16284D" />
    <line x1="57.2" y1="67.0" x2="57.2" y2="-61.0" className="lp-iso-thread-up" />
    <g className="lp-float-b">
      <polygon points="123.0,-55.0 74.5,-27.0 74.5,-31.0 123.0,-59.0" fill="#BCD1F8" />
      <polygon points="12.1,-63.0 74.5,-27.0 74.5,-31.0 12.1,-67.0" fill="#E4EDFD" />
      <polygon points="60.6,-95.0 123.0,-59.0 74.5,-31.0 12.1,-67.0" fill="#FFFFFF" />
      <polygon points="123.0,-63.0 74.5,-35.0 74.5,-42.0 123.0,-70.0" fill="#1A4DB8" />
      <polygon points="12.1,-71.0 74.5,-35.0 74.5,-42.0 12.1,-78.0" fill="#2563DE" />
      <polygon points="60.6,-106.0 123.0,-70.0 74.5,-42.0 12.1,-78.0" fill="#4C81EC" />
      <polygon points="60.6,-94.0 90.1,-77.0 64.1,-62.0 34.6,-79.0" fill="#FFFFFF" />
      <text transform="matrix(0.8660 -0.5 0.8660 0.5 46.8 -76.0)" className="lp-iso-label" fill="#0B1B3F">
        {"CHARGE"}
      </text>
      <text transform="matrix(0.8660 -0.5 0.8660 0.5 56.3 -70.5)" className="lp-iso-label" fill="#0B1B3F">
        {"SHEET"}
      </text>
    </g>
    <g className="lp-iso-badge lp-float-b">
      <circle cx="138.6" cy="-86.0" r="19" fill="#F2A33A" />
      <circle cx="138.6" cy="-86.0" r="19" fill="none" className="lp-iso-badge-ring" />
      <path d="M130.6 -85.6 L136.7 -79.5 L147.1 -91.7" className="lp-iso-check" />
    </g>
    <g className="lp-iso-bubble lp-float-a">
      <rect x="-145.0" y="-12.0" width="96" height="36" rx="12" fill="#FFFFFF" />
      <path d="M-131.0 23.0 l-2 11 l12 -11 z" fill="#FFFFFF" />
      <text x="-97.0" y="12.0" className="lp-iso-q" fill="#0B1B3F">
        {"कब? कहाँ?"}
      </text>
    </g>
    <g className="lp-iso-chip lp-float-b">
      <rect x="-5.6" y="108.0" width="136" height="32" rx="10" fill="#FFFFFF" className="lp-iso-chip-box" />
      <circle cx="11.4" cy="124.0" r="8" fill="#1D5BD8" />
      <path d="M7.4 124.0 l3 3 5.2-5.8" className="lp-iso-mini-check" />
      <text x="26.4" y="128.8" className="lp-iso-chip-text" fill="#A85A0C">
        {"9 questions"}
      </text>
    </g>
    <g className="lp-iso-chip lp-float-a">
      <rect x="130.5" y="6.0" width="120" height="32" rx="10" fill="#FFFFFF" className="lp-iso-chip-box" />
      <circle cx="147.5" cy="22.0" r="8" fill="#1D5BD8" />
      <path d="M143.5 22.0 l3 3 5.2-5.8" className="lp-iso-mini-check" />
      <text x="162.5" y="26.8" className="lp-iso-chip-text" fill="#A85A0C">
        {"5 exhibits"}
      </text>
    </g>
    <g className="lp-iso-pill">
      <rect x="-244.3" y="102.0" width="104" height="30" rx="15.0" fill="#0B1B3F" />
      <text x="-192.3" y="122.5" className="lp-iso-pill-text lp-iso-pill-lg" fill="#FFFFFF">
        {"Duty desk"}
      </text>
    </g>
    <g className="lp-iso-pill">
      <rect x="-88.6" y="208.0" width="146" height="30" rx="15.0" fill="#0B1B3F" />
      <text x="-15.6" y="228.5" className="lp-iso-pill-text lp-iso-pill-lg" fill="#FFFFFF">
        {"Interview room"}
      </text>
    </g>
    <g className="lp-iso-pill">
      <rect x="203.6" y="176.0" width="102" height="30" rx="15.0" fill="#0B1B3F" />
      <text x="254.6" y="196.5" className="lp-iso-pill-text lp-iso-pill-lg" fill="#FFFFFF">
        {"Malkhana"}
      </text>
    </g>
    <g className="lp-iso-pill">
      <rect x="-121.2" y="42.0" width="128" height="30" rx="15.0" fill="#0B1B3F" />
      <text x="-57.2" y="62.5" className="lp-iso-pill-text lp-iso-pill-lg" fill="#FFFFFF">
        {"SHO's office"}
      </text>
    </g>
    </svg>
  );
}
